import { render, staticRenderFns } from "./Departmental-NoClose-issue.vue?vue&type=template&id=f785e45e"
import script from "./Departmental-NoClose-issue.vue?vue&type=script&lang=js"
export * from "./Departmental-NoClose-issue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports